import React from 'react';
import { motion } from 'framer-motion';
export function PainPointSection() {
  return <section className="bg-gradient-to-b from-[#1a0f0f] to-[#2C1810] py-10 px-4" data-id="element-140">
      <div className="max-w-3xl mx-auto text-center" data-id="element-141">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-white uppercase mb-8 leading-tight" data-id="element-142">
          Si sos docente de Historia, esto te va a sonar demasiado familiar.
        </motion.h2>

        <div className="w-16 h-1 bg-[#D4726A] mx-auto mb-8 rounded-full opacity-50" data-id="element-143"></div>

        <div className="space-y-5 text-base md:text-lg text-[#F4F4F2] font-medium leading-relaxed text-left" data-id="element-144">
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-145">
            Pasás el día lidiando con alumnos que no colaboran… tratando de
            sostener la clase como podés.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-146">
            Cuando llegas a casa, tu familia te necesita. Hay cosas que
            resolver. Responsabilidades que no pueden esperar. ¿Y la
            planificación? Queda para lo último, y terminás haciendo todo sin
            ganas:
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="grid grid-cols-1 md:grid-cols-2 gap-2 py-2" data-id="element-147">
            <span className="bg-[#D4726A]/10 text-[#E8A49C] rounded px-3 py-2 text-sm md:text-base font-bold border border-[#D4726A]/20 flex items-center gap-2" data-id="element-148">
              Planificaciones a medias
            </span>
            <span className="bg-[#D4726A]/10 text-[#E8A49C] rounded px-3 py-2 text-sm md:text-base font-bold border border-[#D4726A]/20 flex items-center gap-2" data-id="element-149">
              Inventando actividades sobre la marcha
            </span>
            <span className="bg-[#D4726A]/10 text-[#E8A49C] rounded px-3 py-2 text-sm md:text-base font-bold border border-[#D4726A]/20 flex items-center gap-2" data-id="element-150">
              Armando diapositivas como podés
            </span>
            <span className="bg-[#D4726A]/10 text-[#E8A49C] rounded px-3 py-2 text-sm md:text-base font-bold border border-[#D4726A]/20 flex items-center gap-2" data-id="element-151">
              Pensar evaluaciones a ultimo momento
            </span>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-152">
            Noches desvelandote... robándole horas al fin de semana... Y aun
            así… queda esa sensación constante de que nunca es suficiente. Que
            siempre falta algo.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-153">
            Estás sosteniendo demasiado… sin ayuda. Y la verdad es incómoda,
            pero clara:
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="mt-6 p-5 border-l-4 border-[#D4726A] bg-white/5 rounded-r-lg" data-id="element-154">
            <p className="text-xl md:text-2xl font-bold text-[#E8A49C] leading-tight" data-id="element-155">
              Ningún docente debería tener que crear todo desde cero, todos los
              años, mientras intenta sostener su vida personal al mismo tiempo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}